export default {
  form: {
    address: {
      delivery: {
        placeholder: 'Hae toimitusosoitettasi',
      },
      placeholder: 'Syötä osoite löytääksesi lähimmän sijainnin',
    },
  },
  toasts: {
    failed_to_load_stores: 'Myymälöiden lataaminen epäonnistui, päivitä sivu',
  },
  errors: {
    no_delivery_companies: 'Toimitus ei ole saatavilla tähän osoitteeseen',
    delivery_not_available: 'Valitettavasti emme tarjoa toimitusta tällä hetkellä',
    location_unavailable: 'Sijaintiasi ei saatu käyttöön, ota käyttöoikeudet käyttöön tai syötä osoite manuaalisesti',
    location_lookup_failed: 'Osoitettasi ei löytynyt, yritä uudelleen',
    address_suggestions_unavailable: 'Osoite-ehdotuksia ei voitu ladata.',
  },
  buttons: {
    use_current_location: 'Käytä nykyistä sijaintiani',
    locating: 'Etsitään sijaintiasi…',
    retry: 'Yritä uudelleen',
  },
};
